if (!customElements.get('powerlung-model-selector')) {
  customElements.define(
    'powerlung-model-selector',
    class PowerLungModelSelector extends HTMLElement {
      connectedCallback() {
        this.chips = Array.from(this.querySelectorAll('.powerlung-model-guide__chip'));
        this.cards = Array.from(this.querySelectorAll('.powerlung-model-card'));
        this.segments = Array.from(this.querySelectorAll('.powerlung-model-guide__scale-segment'));

        this.chips.forEach((chip) => {
          chip.addEventListener('click', () => this.select(chip.dataset.audience || ''));
        });
      }

      select(audience) {
        this.chips.forEach((chip) => {
          chip.setAttribute('aria-pressed', String((chip.dataset.audience || '') === audience));
        });

        const matchedModels = [];
        this.cards.forEach((card) => {
          const audiences = (card.dataset.audiences || '').split(' ').filter(Boolean);
          const isMatch = audience !== '' && audiences.includes(audience);
          card.classList.toggle('is-match', isMatch);
          card.classList.toggle('is-dimmed', audience !== '' && !isMatch);
          if (isMatch) matchedModels.push(card.dataset.model);
        });

        this.segments.forEach((segment) => {
          segment.classList.toggle('is-dimmed', audience !== '' && !matchedModels.includes(segment.dataset.model));
        });

        const firstMatch = this.cards.find((card) => card.classList.contains('is-match'));
        if (firstMatch && window.matchMedia('(max-width: 989px)').matches) {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          firstMatch.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }
      }
    }
  );
}
